import React from 'react';
import VirtualTourInfoTable from './VirtualTourInfoTable';
import TourListingList from './TourListingList';

function VirtualTourDetailsBody({
  virtualTour,
  listing = {},
  retsId,
  dashboardId,
  virtualShowingDomain,
  isCancelled,
}) {
  return (
    <div className="content animate-panel">
      <div className="row">
        <div className="col-md-12">
          <div className="hpanel">
            <div className="panel-body">
              <div
                className="row appointment-details"
                style={{ textTransform: 'none' }}
              >
                <div className="col-md-12 m-b-sm">
                  {listing.line1 && !isCancelled && (
                    <p className="alert alert-success" style={{ margin: '0' }}>
                      {listing && `${listing.line1} ${listing.line2 || ''}`} has
                      been added to your 3D Virtual Tour Conference
                    </p>
                  )}
                  {isCancelled && (
                    <p className="alert alert-danger" style={{ margin: '0' }}>
                      Virtual Tour has been cancelled
                    </p>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 m-b-sm">
                  <label>3D Virtual Tour Details</label>
                  <VirtualTourInfoTable
                    virtualTour={virtualTour}
                    retsId={retsId}
                    dashboardId={dashboardId}
                    virtualShowingDomain={virtualShowingDomain}
                  />
                </div>

                <div className="col-md-6">
                  <div className="col-md-12 row">
                    <div
                      style={{ background: 'whitesmoke', padding: '12px 0px' }}
                    >
                      <h5 style={{ paddingLeft: '12px' }}>
                        Properties On Tour
                      </h5>
                    </div>
                    <TourListingList
                      virtualTour={virtualTour}
                      retsId={retsId}
                      dashboardId={dashboardId}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VirtualTourDetailsBody;
